import Api from '@/services/Api'

export default {
  fetchOrders () {
    return Api().get('orders')
  },

  fetchOrderTWCdetailsLimit (page, rowsPerPage, search, enabledStatuses, enabledInstallorDelivery) {
    return Api().post('limitedOrderTWCdetails/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      enabledStatuses: enabledStatuses,
      enabledInstallorDelivery: enabledInstallorDelivery
    })
  },

  fetchOrdersLimit (page, rowsPerPage, search, enabledStatuses, enabledInstallorDelivery, enabledOnlineorOffline, searchUsers) {
    return Api().post('limitedOrders/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      enabledStatuses: enabledStatuses,
      enabledInstallorDelivery: enabledInstallorDelivery,
      enabledOnlineorOffline: enabledOnlineorOffline,
      searchUsers: searchUsers
    })
  },

  countOrders (search, enabledStatuses, enabledInstallorDelivery, enabledOnlineorOffline, searchUsers) {
    return Api().post('orderCount', {
      search: search,
      enabledStatuses: enabledStatuses,
      enabledInstallorDelivery: enabledInstallorDelivery,
      enabledOnlineorOffline: enabledOnlineorOffline,
      searchUsers: searchUsers
    })
  },

  usersOrders () {
    return Api().post('orderUsers')
  },

  addOrder (order) {
    return Api().post('orders', order)
  },

  fetchCartOrders (params) {
    return Api().post('fetchCartOrders', params)
  },

  updateOrder (params) {
    return Api().put('order/' + params._id, params)
  },

  getOrder (params) {
    return Api().get('order/' + params.id)
  },

  getOrderTWCDetails (params) {
    return Api().get('getOrderTWCDetails/' + params.id)
  },

  deleteOrder (id) {
    return Api().delete('order/' + id)
  },

  getItems (id) {
    return Api().get('itemsOfOrder/' + id)
  },

  getFreeSamples (id) {
    return Api().get('freeSamplesOfOrder/' + id)
  },

  getCustomer (id) {
    return Api().get('customer/' + id)
  },

  duplicateOrder (id) {
    return Api().get('order/duplicate/' + id)
  },

  archiveOrder (id) {
    return Api().get('order/archive/' + id)
  },

  upgradeQuote (id) {
    return Api().get('order/upgrade/' + id)
  },
  updateInstallationStatus (params) {
    return Api().post('order/updateInstallationStatus', params)
  },
  updateInstallationNotes (params) {
    return Api().post('order/updateInstallationNotes', params)
  },
  updateCMBookedDate (params) {
    return Api().post('order/updateCMBookedDate', params)
  },
  updateInstallBookedDate (params) {
    return Api().post('order/updateInstallBookedDate', params)
  },
  updateCheckMeasureImg (params) {
    return Api().post('order/updateCheckMeasureImg', params)
  },

  fetchArchivedOrders () {
    return Api().get('orders/archived')
  },
  fetchLimitedArchivedOrders (page, rowsPerPage, search, searchUsers) {
    return Api().post('limitedArchivedOrders', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      searchUsers: searchUsers
    })
  },

  fetchQuotes () {
    return Api().get('quotes')
  },

  fetchlimitedQuotes (page, rowsPerPage, search, searchUsers) {
    return Api().post('limitedQuotes/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      searchUsers: searchUsers
    })
  },
  fetchlimitedQuotes2 (page, rowsPerPage, search, searchUsers, quoteAge = '') {
    return Api().post('limitedQuotes2/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      searchUsers: searchUsers,
      quoteAge: quoteAge
    })
  },
  getCMReceivedQuotes (userID) {
    return Api().post('getCMReceivedQuotes/', {
      userID: userID
    })
  },

  countQuotes (search, searchUsers) {
    return Api().post('quoteCount', {
      search: search,
      searchUsers: searchUsers
    })
  },
  countArchivedOrders (search, searchUsers) {
    return Api().post('archivedOrderCount', {
      search: search,
      searchUsers: searchUsers
    })
  },
  countOrderTWCdetails (page, rowsPerPage, search, enabledStatuses, enabledInstallorDelivery) {
    return Api().post('orderTWCdetailsCount', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search,
      enabledStatuses: enabledStatuses,
      enabledInstallorDelivery: enabledInstallorDelivery
    })
  },

  usersQuotes () {
    return Api().post('quoteUsers')
  },

  updateOrderPrice (id, price) {
    return Api().put('order/priceUpdate/' + id, price)
  },

  updateOrderStatus (id, status, updatedBy = null) {
    return Api().put('order/status/' + id, {
      status: status,
      updatedBy: updatedBy
    })
  },
  updateSingle (id, field, value) {
    return Api().put('order/updateSingle/' + id, {
      field: field,
      value: value
    })
  },

  emailQuote (id) {
    return Api().get('quote/email/' + id)
  },

  emailInvoice (id) {
    return Api().get('order/email/' + id)
  },
  emailInvoiceNew (id) {
    return Api().get('order/email2/' + id)
  },

  emailFreeSampleConfirmation (id) {
    return Api().get('freeSample/email/' + id)
  },
  emailFreeSampleInTransit (id) {
    return Api().get('freeSampleInTransit/email/' + id)
  },

  emailTrackingUpdate (id) {
    return Api().get('tracking/email/' + id)
  },
  getTodayTotal () {
    return Api().get('salesToday')
  },
  getWeekTotal () {
    return Api().get('salesWeek')
  },
  getQuarterTotal () {
    return Api().get('salesQuarter')
  },
  getMonthTotal () {
    return Api().get('salesMonth')
  },
  getYearTotal () {
    return Api().get('salesYear')
  },
  getTodaySamples () {
    return Api().get('samplesToday')
  },
  getWeekSamples () {
    return Api().get('samplesWeek')
  },
  getQuarterSamples () {
    return Api().get('samplesQuarter')
  },
  getMonthSamples () {
    return Api().get('samplesMonth')
  },
  getYearSamples () {
    return Api().get('samplesYear')
  },
  getUserSalesData (userID) {
    return Api().get('getUserSalesData/' + userID)
  },
  getDateWiseTotal (year, month, day) {
    return Api().get(`salesDateWise/${year}/${month}/${day}`)
  },
  orderCountByStatus () {
    return Api().get('orderCountByStatus')
  },

  getOrdersOnDay (day) {
    return Api().post('ordersOnDay/', {
      date: day
    })
  },

  getOrderInvoice (id) {
    return Api().get('order/pdf/' + id, { responseType: 'blob' })
  },
  getOrderInstaller (id) {
    return Api().get('order/pdfInstaller/' + id, { responseType: 'blob' })
  },

  getOrderQuote (id) {
    return Api().get('quote/pdf/' + id, {responseType: 'blob'})
  },

  getPrettyOrderQuote (id) {
    return Api().get('prettyQuote/pdf/' + id, {responseType: 'blob'})
  },
  getHomeproOrderQuote (id) {
    return Api().get('homeproQuote/pdf/' + id, {responseType: 'blob'})
  },
  getPrettyOrderQuoteOld (id) {
    return Api().get('prettyQuoteOld/pdf/' + id, {responseType: 'blob'})
  },
  getQuotesAndArchivedCounts (params) {
    return Api().post('getQuotesAndArchivedCounts', params)
  },
  // getQuotesAndArchivedCountsOfUser (userID) {
  //   return Api().get('getQuotesAndArchivedCounts/' + userID)
  // },

  toTWC (order, testing) {
    return Api().post('toTWC/' + testing, order)
  },

  downloadUnsent (id, items) {
    return Api().post('downloadUnsent', {
      id: id,
      items: items
    }, {
      responseType: 'blob'
    })
  },

  downloadCurtainDoc (id, items) {
    return Api().post('downloadCurtainDoc', {
      id: id,
      items: items
    }, {
      responseType: 'blob'
    })
  },
  downloadSoftRomanBlindDoc (id, items) {
    return Api().post('downloadSoftRomanBlindDoc', {
      id: id,
      items: items
    }, {
      responseType: 'blob'
    })
  },
  downloadCMSheet (id) {
    return Api().post('downloadCMSheet', {
      id: id
    }, {
      responseType: 'blob'
    })
  },
  downloadTrackDocument (id, items) {
    return Api().post('downloadTrackDocument', {
      id: id,
      items: items
    }, {
      responseType: 'blob'
    })
  },
  downloadCurtainDocument (id, items) {
    return Api().post('downloadCurtainDocument', {
      id: id,
      items: items
    }, {
      responseType: 'blob'
    })
  },

  importOrder (order) {
    return Api().post('orders/import', order)
  },

  // Cart services
  countCarts (search) {
    return Api().post('cartCount/', {
      search: search
    })
  },

  fetchLimitedCarts (page, rowsPerPage, search) {
    return Api().post('limitedCarts/', {
      page: page,
      rowsPerPage: rowsPerPage,
      search: search
    })
  },
  uploadCMs (formData) {
    // return Api().post('multiple_upload', formData)
    return Api().post('uploadAttachments', formData) // upload to s3
  },
  exportSalesData (params) {
    return Api().post('exportSalesData', params)
  },
  getOrderDetails (params) {
    return Api().post('getOrderDetails', params)
  },
  checkfileexist (file) {
    return Api().get('checkfileexist/' + file)
  },
  ordersImport () {
    return Api().get('ordersImport')
  },
  getInstallationOrders () {
    return Api().get('getInstallationOrders')
  },
  getInstallationOrders2 (params) {
    return Api().post('getInstallationOrders2', params)
  },
  getInTransitOrders () {
    return Api().get('getInTransitOrders')
  },
  markAsCollected (orderID) {
    return Api().put('markAsCollected/' + orderID)
  },
  updateFreeSampleAssignee (orderIDs, userID) {
    return Api().put('updateFreeSampleAssignee/', {
      orderIDs: orderIDs,
      userID: userID
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/OrderService.js